var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 9.29175H5.83331",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 9.2917V5.4417C1.66669 3.7417 3.04169 2.3667 4.74169 2.3667H9.42502C11.125 2.3667 12.5 3.42503 12.5 5.12503",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5667 10.1667C14.15 10.5667 13.95 11.1833 14.1167 11.8166C14.325 12.5916 15.0917 13.0833 15.8917 13.0833H16.6667V14.2917C16.6667 16.1333 15.175 17.625 13.3334 17.625H5.00002C3.15835 17.625 1.66669 16.1333 1.66669 14.2917V8.45833C1.66669 6.61667 3.15835 5.125 5.00002 5.125H13.3334C15.1667 5.125 16.6667 6.625 16.6667 8.45833V9.66663H15.7667C15.3 9.66663 14.875 9.84999 14.5667 10.1667Z",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.5166V12.2333C18.3333 12.7 17.95 13.0833 17.475 13.0833H15.8667C14.9667 13.0833 14.1417 12.425 14.0667 11.525C14.0167 11 14.2167 10.5083 14.5667 10.1667C14.875 9.84999 15.3 9.66663 15.7667 9.66663H17.475C17.95 9.66663 18.3333 10.05 18.3333 10.5166Z",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet3);
export default __webpack_public_path__ + "static/media/wallet-3.60e2ce8235298ed25e78cdba619269da.svg";
export { ForwardRef as ReactComponent };